// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/coins/v2/service.proto (package creativefabrica.coins.v2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ActionPricing, ActionPricingJson, AutoTopUpPack, AutoTopUpPackJson, AutoTopUpSettings, AutoTopUpSettingsJson, CoinDeal, CoinDealJson, CoinDealPaymentStatus, CoinDealPaymentStatusJson, PricingAction, PricingActionJson, StatisticsPeriod, StatisticsPeriodJson, TeamApiKeyStats, TeamApiKeyStatsJson, TeamMemberActivity, TeamMemberActivityJson, TeamMemberMonthlyUsage, TeamMemberMonthlyUsageJson, TeamMemberStats, TeamMemberStatsJson, TeamSettings, TeamSettingsJson, Transaction, TransactionJson, UserTransactionStats, UserTransactionStatsJson } from "./types_pb";
import { file_creativefabrica_coins_v2_types } from "./types_pb";
import type { Surface, SurfaceJson } from "@repo/rpc-types-creativefabrica-common-v1/surface/v1";
import { file_creativefabrica_common_v1_surface_v1_types } from "@repo/rpc-types-creativefabrica-common-v1/surface/v1";
import type { PaginationRequest, PaginationRequestJson, PaginationResponse, PaginationResponseJson } from "@repo/rpc-types-creativefabrica-common-v1";
import { file_creativefabrica_common_v1_types } from "@repo/rpc-types-creativefabrica-common-v1";
import type { TeamAvatarStatus, TeamAvatarStatusJson } from "../../teams/v2/types_pb";
import { file_creativefabrica_teams_v2_types } from "../../teams/v2/types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/coins/v2/service.proto.
 */
export const file_creativefabrica_coins_v2_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_creativefabrica_coins_v2_types, file_creativefabrica_common_v1_surface_v1_types, file_creativefabrica_common_v1_types, file_creativefabrica_teams_v2_types]);

/**
 * @generated from message creativefabrica.coins.v2.GetPricingRequest
 */
export type GetPricingRequest = Message<"creativefabrica.coins.v2.GetPricingRequest"> & {
  /**
   * If set, the response contains pricing for just that action; otherwise
   * it contains pricing for every known action.
   *
   * @generated from field: optional creativefabrica.coins.v2.PricingAction action = 1;
   */
  action?: PricingAction | undefined;
};

/**
 * @generated from message creativefabrica.coins.v2.GetPricingRequest
 */
export type GetPricingRequestJson = {
  /**
   * If set, the response contains pricing for just that action; otherwise
   * it contains pricing for every known action.
   *
   * @generated from field: optional creativefabrica.coins.v2.PricingAction action = 1;
   */
  action?: PricingActionJson;
};

/**
 * Describes the message creativefabrica.coins.v2.GetPricingRequest.
 * Use `create(GetPricingRequestSchema)` to create a new message.
 */
export const GetPricingRequestSchema: GenMessage<GetPricingRequest, {jsonType: GetPricingRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 0);

/**
 * @generated from message creativefabrica.coins.v2.GetPricingResponse
 */
export type GetPricingResponse = Message<"creativefabrica.coins.v2.GetPricingResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.coins.v2.ActionPricing items = 1;
   */
  items: ActionPricing[];
};

/**
 * @generated from message creativefabrica.coins.v2.GetPricingResponse
 */
export type GetPricingResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.coins.v2.ActionPricing items = 1;
   */
  items?: ActionPricingJson[];
};

/**
 * Describes the message creativefabrica.coins.v2.GetPricingResponse.
 * Use `create(GetPricingResponseSchema)` to create a new message.
 */
export const GetPricingResponseSchema: GenMessage<GetPricingResponse, {jsonType: GetPricingResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 1);

/**
 * The authenticated user is inferred from the request context.
 *
 * @generated from message creativefabrica.coins.v2.GetBalanceRequest
 */
export type GetBalanceRequest = Message<"creativefabrica.coins.v2.GetBalanceRequest"> & {
};

/**
 * The authenticated user is inferred from the request context.
 *
 * @generated from message creativefabrica.coins.v2.GetBalanceRequest
 */
export type GetBalanceRequestJson = {
};

/**
 * Describes the message creativefabrica.coins.v2.GetBalanceRequest.
 * Use `create(GetBalanceRequestSchema)` to create a new message.
 */
export const GetBalanceRequestSchema: GenMessage<GetBalanceRequest, {jsonType: GetBalanceRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 2);

/**
 * @generated from message creativefabrica.coins.v2.GetBalanceResponse
 */
export type GetBalanceResponse = Message<"creativefabrica.coins.v2.GetBalanceResponse"> & {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance: bigint;

  /**
   * @generated from field: int64 team_balance = 2;
   */
  teamBalance: bigint;

  /**
   * @generated from field: int64 team_user_balance = 3;
   */
  teamUserBalance: bigint;
};

/**
 * @generated from message creativefabrica.coins.v2.GetBalanceResponse
 */
export type GetBalanceResponseJson = {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance?: string;

  /**
   * @generated from field: int64 team_balance = 2;
   */
  teamBalance?: string;

  /**
   * @generated from field: int64 team_user_balance = 3;
   */
  teamUserBalance?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.GetBalanceResponse.
 * Use `create(GetBalanceResponseSchema)` to create a new message.
 */
export const GetBalanceResponseSchema: GenMessage<GetBalanceResponse, {jsonType: GetBalanceResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 3);

/**
 * The authenticated user is inferred from the request context.
 * An omitted surface means studio, so callers that predate the field keep
 * the studio settings they always read.
 *
 * @generated from message creativefabrica.coins.v2.GetAutoTopUpSettingsRequest
 */
export type GetAutoTopUpSettingsRequest = Message<"creativefabrica.coins.v2.GetAutoTopUpSettingsRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 1;
   */
  surface: Surface;
};

/**
 * The authenticated user is inferred from the request context.
 * An omitted surface means studio, so callers that predate the field keep
 * the studio settings they always read.
 *
 * @generated from message creativefabrica.coins.v2.GetAutoTopUpSettingsRequest
 */
export type GetAutoTopUpSettingsRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 1;
   */
  surface?: SurfaceJson;
};

/**
 * Describes the message creativefabrica.coins.v2.GetAutoTopUpSettingsRequest.
 * Use `create(GetAutoTopUpSettingsRequestSchema)` to create a new message.
 */
export const GetAutoTopUpSettingsRequestSchema: GenMessage<GetAutoTopUpSettingsRequest, {jsonType: GetAutoTopUpSettingsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 4);

/**
 * @generated from message creativefabrica.coins.v2.GetAutoTopUpSettingsResponse
 */
export type GetAutoTopUpSettingsResponse = Message<"creativefabrica.coins.v2.GetAutoTopUpSettingsResponse"> & {
  /**
   * @generated from field: creativefabrica.coins.v2.AutoTopUpSettings settings = 1;
   */
  settings?: AutoTopUpSettings | undefined;
};

/**
 * @generated from message creativefabrica.coins.v2.GetAutoTopUpSettingsResponse
 */
export type GetAutoTopUpSettingsResponseJson = {
  /**
   * @generated from field: creativefabrica.coins.v2.AutoTopUpSettings settings = 1;
   */
  settings?: AutoTopUpSettingsJson;
};

/**
 * Describes the message creativefabrica.coins.v2.GetAutoTopUpSettingsResponse.
 * Use `create(GetAutoTopUpSettingsResponseSchema)` to create a new message.
 */
export const GetAutoTopUpSettingsResponseSchema: GenMessage<GetAutoTopUpSettingsResponse, {jsonType: GetAutoTopUpSettingsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 5);

/**
 * Updates one or both settings atomically. At least one field must be set.
 * The authenticated user is inferred from the request context.
 * An omitted surface means studio.
 *
 * @generated from message creativefabrica.coins.v2.UpdateAutoTopUpSettingsRequest
 */
export type UpdateAutoTopUpSettingsRequest = Message<"creativefabrica.coins.v2.UpdateAutoTopUpSettingsRequest"> & {
  /**
   * @generated from field: optional bool enabled = 1;
   */
  enabled?: boolean | undefined;

  /**
   * @generated from field: optional creativefabrica.coins.v2.AutoTopUpPack pack = 2;
   */
  pack?: AutoTopUpPack | undefined;

  /**
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 3;
   */
  surface: Surface;
};

/**
 * Updates one or both settings atomically. At least one field must be set.
 * The authenticated user is inferred from the request context.
 * An omitted surface means studio.
 *
 * @generated from message creativefabrica.coins.v2.UpdateAutoTopUpSettingsRequest
 */
export type UpdateAutoTopUpSettingsRequestJson = {
  /**
   * @generated from field: optional bool enabled = 1;
   */
  enabled?: boolean;

  /**
   * @generated from field: optional creativefabrica.coins.v2.AutoTopUpPack pack = 2;
   */
  pack?: AutoTopUpPackJson;

  /**
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 3;
   */
  surface?: SurfaceJson;
};

/**
 * Describes the message creativefabrica.coins.v2.UpdateAutoTopUpSettingsRequest.
 * Use `create(UpdateAutoTopUpSettingsRequestSchema)` to create a new message.
 */
export const UpdateAutoTopUpSettingsRequestSchema: GenMessage<UpdateAutoTopUpSettingsRequest, {jsonType: UpdateAutoTopUpSettingsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 6);

/**
 * @generated from message creativefabrica.coins.v2.UpdateAutoTopUpSettingsResponse
 */
export type UpdateAutoTopUpSettingsResponse = Message<"creativefabrica.coins.v2.UpdateAutoTopUpSettingsResponse"> & {
  /**
   * @generated from field: creativefabrica.coins.v2.AutoTopUpSettings settings = 1;
   */
  settings?: AutoTopUpSettings | undefined;
};

/**
 * @generated from message creativefabrica.coins.v2.UpdateAutoTopUpSettingsResponse
 */
export type UpdateAutoTopUpSettingsResponseJson = {
  /**
   * @generated from field: creativefabrica.coins.v2.AutoTopUpSettings settings = 1;
   */
  settings?: AutoTopUpSettingsJson;
};

/**
 * Describes the message creativefabrica.coins.v2.UpdateAutoTopUpSettingsResponse.
 * Use `create(UpdateAutoTopUpSettingsResponseSchema)` to create a new message.
 */
export const UpdateAutoTopUpSettingsResponseSchema: GenMessage<UpdateAutoTopUpSettingsResponse, {jsonType: UpdateAutoTopUpSettingsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 7);

/**
 * @generated from message creativefabrica.coins.v2.GetTeamSettingsRequest
 */
export type GetTeamSettingsRequest = Message<"creativefabrica.coins.v2.GetTeamSettingsRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;
};

/**
 * @generated from message creativefabrica.coins.v2.GetTeamSettingsRequest
 */
export type GetTeamSettingsRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.GetTeamSettingsRequest.
 * Use `create(GetTeamSettingsRequestSchema)` to create a new message.
 */
export const GetTeamSettingsRequestSchema: GenMessage<GetTeamSettingsRequest, {jsonType: GetTeamSettingsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 8);

/**
 * @generated from message creativefabrica.coins.v2.GetTeamSettingsResponse
 */
export type GetTeamSettingsResponse = Message<"creativefabrica.coins.v2.GetTeamSettingsResponse"> & {
  /**
   * @generated from field: creativefabrica.coins.v2.TeamSettings settings = 1;
   */
  settings?: TeamSettings | undefined;
};

/**
 * @generated from message creativefabrica.coins.v2.GetTeamSettingsResponse
 */
export type GetTeamSettingsResponseJson = {
  /**
   * @generated from field: creativefabrica.coins.v2.TeamSettings settings = 1;
   */
  settings?: TeamSettingsJson;
};

/**
 * Describes the message creativefabrica.coins.v2.GetTeamSettingsResponse.
 * Use `create(GetTeamSettingsResponseSchema)` to create a new message.
 */
export const GetTeamSettingsResponseSchema: GenMessage<GetTeamSettingsResponse, {jsonType: GetTeamSettingsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 9);

/**
 * Replaces the team's coin settings with the given values.
 *
 * @generated from message creativefabrica.coins.v2.UpdateTeamSettingsRequest
 */
export type UpdateTeamSettingsRequest = Message<"creativefabrica.coins.v2.UpdateTeamSettingsRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: creativefabrica.coins.v2.TeamSettings settings = 2;
   */
  settings?: TeamSettings | undefined;
};

/**
 * Replaces the team's coin settings with the given values.
 *
 * @generated from message creativefabrica.coins.v2.UpdateTeamSettingsRequest
 */
export type UpdateTeamSettingsRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;

  /**
   * @generated from field: creativefabrica.coins.v2.TeamSettings settings = 2;
   */
  settings?: TeamSettingsJson;
};

/**
 * Describes the message creativefabrica.coins.v2.UpdateTeamSettingsRequest.
 * Use `create(UpdateTeamSettingsRequestSchema)` to create a new message.
 */
export const UpdateTeamSettingsRequestSchema: GenMessage<UpdateTeamSettingsRequest, {jsonType: UpdateTeamSettingsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 10);

/**
 * @generated from message creativefabrica.coins.v2.UpdateTeamSettingsResponse
 */
export type UpdateTeamSettingsResponse = Message<"creativefabrica.coins.v2.UpdateTeamSettingsResponse"> & {
  /**
   * @generated from field: creativefabrica.coins.v2.TeamSettings settings = 1;
   */
  settings?: TeamSettings | undefined;
};

/**
 * @generated from message creativefabrica.coins.v2.UpdateTeamSettingsResponse
 */
export type UpdateTeamSettingsResponseJson = {
  /**
   * @generated from field: creativefabrica.coins.v2.TeamSettings settings = 1;
   */
  settings?: TeamSettingsJson;
};

/**
 * Describes the message creativefabrica.coins.v2.UpdateTeamSettingsResponse.
 * Use `create(UpdateTeamSettingsResponseSchema)` to create a new message.
 */
export const UpdateTeamSettingsResponseSchema: GenMessage<UpdateTeamSettingsResponse, {jsonType: UpdateTeamSettingsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 11);

/**
 * @generated from message creativefabrica.coins.v2.ListTeamMembersStatsRequest
 */
export type ListTeamMembersStatsRequest = Message<"creativefabrica.coins.v2.ListTeamMembersStatsRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;

  /**
   * @generated from field: creativefabrica.coins.v2.StatisticsPeriod period = 2;
   */
  period: StatisticsPeriod;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId: string;
};

/**
 * @generated from message creativefabrica.coins.v2.ListTeamMembersStatsRequest
 */
export type ListTeamMembersStatsRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;

  /**
   * @generated from field: creativefabrica.coins.v2.StatisticsPeriod period = 2;
   */
  period?: StatisticsPeriodJson;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.ListTeamMembersStatsRequest.
 * Use `create(ListTeamMembersStatsRequestSchema)` to create a new message.
 */
export const ListTeamMembersStatsRequestSchema: GenMessage<ListTeamMembersStatsRequest, {jsonType: ListTeamMembersStatsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 12);

/**
 * @generated from message creativefabrica.coins.v2.ListTeamMembersStatsResponse
 */
export type ListTeamMembersStatsResponse = Message<"creativefabrica.coins.v2.ListTeamMembersStatsResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse | undefined;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.TeamMemberStats stats = 2;
   */
  stats: TeamMemberStats[];

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;

  /**
   * @generated from field: string avatar_thumbnail_url = 4;
   */
  avatarThumbnailUrl: string;

  /**
   * @generated from field: creativefabrica.teams.v2.TeamAvatarStatus avatar_status = 5;
   */
  avatarStatus: TeamAvatarStatus;
};

/**
 * @generated from message creativefabrica.coins.v2.ListTeamMembersStatsResponse
 */
export type ListTeamMembersStatsResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponseJson;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.TeamMemberStats stats = 2;
   */
  stats?: TeamMemberStatsJson[];

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl?: string;

  /**
   * @generated from field: string avatar_thumbnail_url = 4;
   */
  avatarThumbnailUrl?: string;

  /**
   * @generated from field: creativefabrica.teams.v2.TeamAvatarStatus avatar_status = 5;
   */
  avatarStatus?: TeamAvatarStatusJson;
};

/**
 * Describes the message creativefabrica.coins.v2.ListTeamMembersStatsResponse.
 * Use `create(ListTeamMembersStatsResponseSchema)` to create a new message.
 */
export const ListTeamMembersStatsResponseSchema: GenMessage<ListTeamMembersStatsResponse, {jsonType: ListTeamMembersStatsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 13);

/**
 * @generated from message creativefabrica.coins.v2.ListTeamApiKeyStatsRequest
 */
export type ListTeamApiKeyStatsRequest = Message<"creativefabrica.coins.v2.ListTeamApiKeyStatsRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;

  /**
   * @generated from field: creativefabrica.coins.v2.StatisticsPeriod period = 2;
   */
  period: StatisticsPeriod;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId: string;
};

/**
 * @generated from message creativefabrica.coins.v2.ListTeamApiKeyStatsRequest
 */
export type ListTeamApiKeyStatsRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;

  /**
   * @generated from field: creativefabrica.coins.v2.StatisticsPeriod period = 2;
   */
  period?: StatisticsPeriodJson;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.ListTeamApiKeyStatsRequest.
 * Use `create(ListTeamApiKeyStatsRequestSchema)` to create a new message.
 */
export const ListTeamApiKeyStatsRequestSchema: GenMessage<ListTeamApiKeyStatsRequest, {jsonType: ListTeamApiKeyStatsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 14);

/**
 * @generated from message creativefabrica.coins.v2.ListTeamApiKeyStatsResponse
 */
export type ListTeamApiKeyStatsResponse = Message<"creativefabrica.coins.v2.ListTeamApiKeyStatsResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse | undefined;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.TeamApiKeyStats stats = 2;
   */
  stats: TeamApiKeyStats[];
};

/**
 * @generated from message creativefabrica.coins.v2.ListTeamApiKeyStatsResponse
 */
export type ListTeamApiKeyStatsResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponseJson;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.TeamApiKeyStats stats = 2;
   */
  stats?: TeamApiKeyStatsJson[];
};

/**
 * Describes the message creativefabrica.coins.v2.ListTeamApiKeyStatsResponse.
 * Use `create(ListTeamApiKeyStatsResponseSchema)` to create a new message.
 */
export const ListTeamApiKeyStatsResponseSchema: GenMessage<ListTeamApiKeyStatsResponse, {jsonType: ListTeamApiKeyStatsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 15);

/**
 * @generated from message creativefabrica.coins.v2.ListUserTransactionStatsRequest
 */
export type ListUserTransactionStatsRequest = Message<"creativefabrica.coins.v2.ListUserTransactionStatsRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;

  /**
   * @generated from field: creativefabrica.coins.v2.StatisticsPeriod period = 2;
   */
  period: StatisticsPeriod;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId: string;
};

/**
 * @generated from message creativefabrica.coins.v2.ListUserTransactionStatsRequest
 */
export type ListUserTransactionStatsRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;

  /**
   * @generated from field: creativefabrica.coins.v2.StatisticsPeriod period = 2;
   */
  period?: StatisticsPeriodJson;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.ListUserTransactionStatsRequest.
 * Use `create(ListUserTransactionStatsRequestSchema)` to create a new message.
 */
export const ListUserTransactionStatsRequestSchema: GenMessage<ListUserTransactionStatsRequest, {jsonType: ListUserTransactionStatsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 16);

/**
 * @generated from message creativefabrica.coins.v2.ListUserTransactionStatsResponse
 */
export type ListUserTransactionStatsResponse = Message<"creativefabrica.coins.v2.ListUserTransactionStatsResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse | undefined;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.UserTransactionStats usage_stats = 2;
   */
  usageStats: UserTransactionStats[];

  /**
   * @generated from field: int64 personal_coins_total = 3;
   */
  personalCoinsTotal: bigint;

  /**
   * @generated from field: int64 personal_coins_used = 4;
   */
  personalCoinsUsed: bigint;
};

/**
 * @generated from message creativefabrica.coins.v2.ListUserTransactionStatsResponse
 */
export type ListUserTransactionStatsResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponseJson;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.UserTransactionStats usage_stats = 2;
   */
  usageStats?: UserTransactionStatsJson[];

  /**
   * @generated from field: int64 personal_coins_total = 3;
   */
  personalCoinsTotal?: string;

  /**
   * @generated from field: int64 personal_coins_used = 4;
   */
  personalCoinsUsed?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.ListUserTransactionStatsResponse.
 * Use `create(ListUserTransactionStatsResponseSchema)` to create a new message.
 */
export const ListUserTransactionStatsResponseSchema: GenMessage<ListUserTransactionStatsResponse, {jsonType: ListUserTransactionStatsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 17);

/**
 * The team comes from the request context. Owners and admins may name any
 * member in user_id; everyone else may only read themselves.
 *
 * @generated from message creativefabrica.coins.v2.ListTeamMemberMonthlyUsageRequest
 */
export type ListTeamMemberMonthlyUsageRequest = Message<"creativefabrica.coins.v2.ListTeamMemberMonthlyUsageRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;

  /**
   * user_id selects whose usage to return. Empty means the caller.
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * The team comes from the request context. Owners and admins may name any
 * member in user_id; everyone else may only read themselves.
 *
 * @generated from message creativefabrica.coins.v2.ListTeamMemberMonthlyUsageRequest
 */
export type ListTeamMemberMonthlyUsageRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;

  /**
   * user_id selects whose usage to return. Empty means the caller.
   *
   * @generated from field: string user_id = 2;
   */
  userId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.ListTeamMemberMonthlyUsageRequest.
 * Use `create(ListTeamMemberMonthlyUsageRequestSchema)` to create a new message.
 */
export const ListTeamMemberMonthlyUsageRequestSchema: GenMessage<ListTeamMemberMonthlyUsageRequest, {jsonType: ListTeamMemberMonthlyUsageRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 18);

/**
 * @generated from message creativefabrica.coins.v2.ListTeamMemberMonthlyUsageResponse
 */
export type ListTeamMemberMonthlyUsageResponse = Message<"creativefabrica.coins.v2.ListTeamMemberMonthlyUsageResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse | undefined;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.TeamMemberMonthlyUsage usage = 2;
   */
  usage: TeamMemberMonthlyUsage[];
};

/**
 * @generated from message creativefabrica.coins.v2.ListTeamMemberMonthlyUsageResponse
 */
export type ListTeamMemberMonthlyUsageResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponseJson;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.TeamMemberMonthlyUsage usage = 2;
   */
  usage?: TeamMemberMonthlyUsageJson[];
};

/**
 * Describes the message creativefabrica.coins.v2.ListTeamMemberMonthlyUsageResponse.
 * Use `create(ListTeamMemberMonthlyUsageResponseSchema)` to create a new message.
 */
export const ListTeamMemberMonthlyUsageResponseSchema: GenMessage<ListTeamMemberMonthlyUsageResponse, {jsonType: ListTeamMemberMonthlyUsageResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 19);

/**
 * The team comes from the request context. Owners and admins may name any
 * member in user_id; everyone else may only read themselves.
 *
 * @generated from message creativefabrica.coins.v2.ListTeamMemberActivityRequest
 */
export type ListTeamMemberActivityRequest = Message<"creativefabrica.coins.v2.ListTeamMemberActivityRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;

  /**
   * user_id selects whose activity to return. Empty means the caller.
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * The team comes from the request context. Owners and admins may name any
 * member in user_id; everyone else may only read themselves.
 *
 * @generated from message creativefabrica.coins.v2.ListTeamMemberActivityRequest
 */
export type ListTeamMemberActivityRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;

  /**
   * user_id selects whose activity to return. Empty means the caller.
   *
   * @generated from field: string user_id = 2;
   */
  userId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.ListTeamMemberActivityRequest.
 * Use `create(ListTeamMemberActivityRequestSchema)` to create a new message.
 */
export const ListTeamMemberActivityRequestSchema: GenMessage<ListTeamMemberActivityRequest, {jsonType: ListTeamMemberActivityRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 20);

/**
 * @generated from message creativefabrica.coins.v2.ListTeamMemberActivityResponse
 */
export type ListTeamMemberActivityResponse = Message<"creativefabrica.coins.v2.ListTeamMemberActivityResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse | undefined;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.TeamMemberActivity activity = 2;
   */
  activity: TeamMemberActivity[];
};

/**
 * @generated from message creativefabrica.coins.v2.ListTeamMemberActivityResponse
 */
export type ListTeamMemberActivityResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponseJson;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.TeamMemberActivity activity = 2;
   */
  activity?: TeamMemberActivityJson[];
};

/**
 * Describes the message creativefabrica.coins.v2.ListTeamMemberActivityResponse.
 * Use `create(ListTeamMemberActivityResponseSchema)` to create a new message.
 */
export const ListTeamMemberActivityResponseSchema: GenMessage<ListTeamMemberActivityResponse, {jsonType: ListTeamMemberActivityResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 21);

/**
 * @generated from message creativefabrica.coins.v2.GetTeamStatisticsRequest
 */
export type GetTeamStatisticsRequest = Message<"creativefabrica.coins.v2.GetTeamStatisticsRequest"> & {
  /**
   * @generated from field: creativefabrica.coins.v2.StatisticsPeriod period = 1;
   */
  period: StatisticsPeriod;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;
};

/**
 * @generated from message creativefabrica.coins.v2.GetTeamStatisticsRequest
 */
export type GetTeamStatisticsRequestJson = {
  /**
   * @generated from field: creativefabrica.coins.v2.StatisticsPeriod period = 1;
   */
  period?: StatisticsPeriodJson;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.GetTeamStatisticsRequest.
 * Use `create(GetTeamStatisticsRequestSchema)` to create a new message.
 */
export const GetTeamStatisticsRequestSchema: GenMessage<GetTeamStatisticsRequest, {jsonType: GetTeamStatisticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 22);

/**
 * @generated from message creativefabrica.coins.v2.GetTeamStatisticsResponse
 */
export type GetTeamStatisticsResponse = Message<"creativefabrica.coins.v2.GetTeamStatisticsResponse"> & {
  /**
   * @generated from field: int64 team_coins_balance = 1;
   */
  teamCoinsBalance: bigint;

  /**
   * @generated from field: int64 team_coins_spent = 2;
   */
  teamCoinsSpent: bigint;

  /**
   * @generated from field: int64 total_coins_balance = 3;
   */
  totalCoinsBalance: bigint;

  /**
   * @generated from field: int64 total_coins_spent = 4;
   */
  totalCoinsSpent: bigint;

  /**
   * @generated from field: int64 total_coins_spent_last_period = 5;
   */
  totalCoinsSpentLastPeriod: bigint;

  /**
   * @generated from field: int64 avg_coins_spent_per_user = 6;
   */
  avgCoinsSpentPerUser: bigint;

  /**
   * @generated from field: int64 avg_coins_spent_per_user_last_period = 7;
   */
  avgCoinsSpentPerUserLastPeriod: bigint;

  /**
   * Members holding an active seat now, and seats the team pays for.
   *
   * @generated from field: int64 active_members = 8;
   */
  activeMembers: bigint;

  /**
   * @generated from field: int64 total_paid_seats = 9;
   */
  totalPaidSeats: bigint;

  /**
   * API-key pool spend in the reported window and the previous window.
   * Already included in team_coins_spent / total_coins_spent via pool used.
   *
   * @generated from field: int64 api_key_coins_spent = 10;
   */
  apiKeyCoinsSpent: bigint;

  /**
   * @generated from field: int64 api_key_coins_spent_last_period = 11;
   */
  apiKeyCoinsSpentLastPeriod: bigint;
};

/**
 * @generated from message creativefabrica.coins.v2.GetTeamStatisticsResponse
 */
export type GetTeamStatisticsResponseJson = {
  /**
   * @generated from field: int64 team_coins_balance = 1;
   */
  teamCoinsBalance?: string;

  /**
   * @generated from field: int64 team_coins_spent = 2;
   */
  teamCoinsSpent?: string;

  /**
   * @generated from field: int64 total_coins_balance = 3;
   */
  totalCoinsBalance?: string;

  /**
   * @generated from field: int64 total_coins_spent = 4;
   */
  totalCoinsSpent?: string;

  /**
   * @generated from field: int64 total_coins_spent_last_period = 5;
   */
  totalCoinsSpentLastPeriod?: string;

  /**
   * @generated from field: int64 avg_coins_spent_per_user = 6;
   */
  avgCoinsSpentPerUser?: string;

  /**
   * @generated from field: int64 avg_coins_spent_per_user_last_period = 7;
   */
  avgCoinsSpentPerUserLastPeriod?: string;

  /**
   * Members holding an active seat now, and seats the team pays for.
   *
   * @generated from field: int64 active_members = 8;
   */
  activeMembers?: string;

  /**
   * @generated from field: int64 total_paid_seats = 9;
   */
  totalPaidSeats?: string;

  /**
   * API-key pool spend in the reported window and the previous window.
   * Already included in team_coins_spent / total_coins_spent via pool used.
   *
   * @generated from field: int64 api_key_coins_spent = 10;
   */
  apiKeyCoinsSpent?: string;

  /**
   * @generated from field: int64 api_key_coins_spent_last_period = 11;
   */
  apiKeyCoinsSpentLastPeriod?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.GetTeamStatisticsResponse.
 * Use `create(GetTeamStatisticsResponseSchema)` to create a new message.
 */
export const GetTeamStatisticsResponseSchema: GenMessage<GetTeamStatisticsResponse, {jsonType: GetTeamStatisticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 23);

/**
 * @generated from message creativefabrica.coins.v2.GetTeamBalanceRequest
 */
export type GetTeamBalanceRequest = Message<"creativefabrica.coins.v2.GetTeamBalanceRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;
};

/**
 * @generated from message creativefabrica.coins.v2.GetTeamBalanceRequest
 */
export type GetTeamBalanceRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.GetTeamBalanceRequest.
 * Use `create(GetTeamBalanceRequestSchema)` to create a new message.
 */
export const GetTeamBalanceRequestSchema: GenMessage<GetTeamBalanceRequest, {jsonType: GetTeamBalanceRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 24);

/**
 * @generated from message creativefabrica.coins.v2.GetTeamBalanceResponse
 */
export type GetTeamBalanceResponse = Message<"creativefabrica.coins.v2.GetTeamBalanceResponse"> & {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance: bigint;
};

/**
 * @generated from message creativefabrica.coins.v2.GetTeamBalanceResponse
 */
export type GetTeamBalanceResponseJson = {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.GetTeamBalanceResponse.
 * Use `create(GetTeamBalanceResponseSchema)` to create a new message.
 */
export const GetTeamBalanceResponseSchema: GenMessage<GetTeamBalanceResponse, {jsonType: GetTeamBalanceResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 25);

/**
 * @generated from message creativefabrica.coins.v2.AdjustTeamBalanceRequest
 */
export type AdjustTeamBalanceRequest = Message<"creativefabrica.coins.v2.AdjustTeamBalanceRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: int64 delta = 2;
   */
  delta: bigint;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * @generated from message creativefabrica.coins.v2.AdjustTeamBalanceRequest
 */
export type AdjustTeamBalanceRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;

  /**
   * @generated from field: int64 delta = 2;
   */
  delta?: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.AdjustTeamBalanceRequest.
 * Use `create(AdjustTeamBalanceRequestSchema)` to create a new message.
 */
export const AdjustTeamBalanceRequestSchema: GenMessage<AdjustTeamBalanceRequest, {jsonType: AdjustTeamBalanceRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 26);

/**
 * @generated from message creativefabrica.coins.v2.AdjustTeamBalanceResponse
 */
export type AdjustTeamBalanceResponse = Message<"creativefabrica.coins.v2.AdjustTeamBalanceResponse"> & {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance: bigint;
};

/**
 * @generated from message creativefabrica.coins.v2.AdjustTeamBalanceResponse
 */
export type AdjustTeamBalanceResponseJson = {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.AdjustTeamBalanceResponse.
 * Use `create(AdjustTeamBalanceResponseSchema)` to create a new message.
 */
export const AdjustTeamBalanceResponseSchema: GenMessage<AdjustTeamBalanceResponse, {jsonType: AdjustTeamBalanceResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 27);

/**
 * @generated from message creativefabrica.coins.v2.ListTeamTransactionsRequest
 */
export type ListTeamTransactionsRequest = Message<"creativefabrica.coins.v2.ListTeamTransactionsRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;
};

/**
 * @generated from message creativefabrica.coins.v2.ListTeamTransactionsRequest
 */
export type ListTeamTransactionsRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.ListTeamTransactionsRequest.
 * Use `create(ListTeamTransactionsRequestSchema)` to create a new message.
 */
export const ListTeamTransactionsRequestSchema: GenMessage<ListTeamTransactionsRequest, {jsonType: ListTeamTransactionsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 28);

/**
 * @generated from message creativefabrica.coins.v2.ListTeamTransactionsResponse
 */
export type ListTeamTransactionsResponse = Message<"creativefabrica.coins.v2.ListTeamTransactionsResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse | undefined;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.Transaction transactions = 2;
   */
  transactions: Transaction[];
};

/**
 * @generated from message creativefabrica.coins.v2.ListTeamTransactionsResponse
 */
export type ListTeamTransactionsResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponseJson;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.Transaction transactions = 2;
   */
  transactions?: TransactionJson[];
};

/**
 * Describes the message creativefabrica.coins.v2.ListTeamTransactionsResponse.
 * Use `create(ListTeamTransactionsResponseSchema)` to create a new message.
 */
export const ListTeamTransactionsResponseSchema: GenMessage<ListTeamTransactionsResponse, {jsonType: ListTeamTransactionsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 29);

/**
 * @generated from message creativefabrica.coins.v2.AdjustTeamMemberBalanceRequest
 */
export type AdjustTeamMemberBalanceRequest = Message<"creativefabrica.coins.v2.AdjustTeamMemberBalanceRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: int64 delta = 3;
   */
  delta: bigint;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * @generated from message creativefabrica.coins.v2.AdjustTeamMemberBalanceRequest
 */
export type AdjustTeamMemberBalanceRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: int64 delta = 3;
   */
  delta?: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.AdjustTeamMemberBalanceRequest.
 * Use `create(AdjustTeamMemberBalanceRequestSchema)` to create a new message.
 */
export const AdjustTeamMemberBalanceRequestSchema: GenMessage<AdjustTeamMemberBalanceRequest, {jsonType: AdjustTeamMemberBalanceRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 30);

/**
 * @generated from message creativefabrica.coins.v2.AdjustTeamMemberBalanceResponse
 */
export type AdjustTeamMemberBalanceResponse = Message<"creativefabrica.coins.v2.AdjustTeamMemberBalanceResponse"> & {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance: bigint;
};

/**
 * @generated from message creativefabrica.coins.v2.AdjustTeamMemberBalanceResponse
 */
export type AdjustTeamMemberBalanceResponseJson = {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.AdjustTeamMemberBalanceResponse.
 * Use `create(AdjustTeamMemberBalanceResponseSchema)` to create a new message.
 */
export const AdjustTeamMemberBalanceResponseSchema: GenMessage<AdjustTeamMemberBalanceResponse, {jsonType: AdjustTeamMemberBalanceResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 31);

/**
 * @generated from message creativefabrica.coins.v2.GetTeamMemberBalanceRequest
 */
export type GetTeamMemberBalanceRequest = Message<"creativefabrica.coins.v2.GetTeamMemberBalanceRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * @generated from message creativefabrica.coins.v2.GetTeamMemberBalanceRequest
 */
export type GetTeamMemberBalanceRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.GetTeamMemberBalanceRequest.
 * Use `create(GetTeamMemberBalanceRequestSchema)` to create a new message.
 */
export const GetTeamMemberBalanceRequestSchema: GenMessage<GetTeamMemberBalanceRequest, {jsonType: GetTeamMemberBalanceRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 32);

/**
 * @generated from message creativefabrica.coins.v2.GetTeamMemberBalanceResponse
 */
export type GetTeamMemberBalanceResponse = Message<"creativefabrica.coins.v2.GetTeamMemberBalanceResponse"> & {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance: bigint;
};

/**
 * @generated from message creativefabrica.coins.v2.GetTeamMemberBalanceResponse
 */
export type GetTeamMemberBalanceResponseJson = {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.GetTeamMemberBalanceResponse.
 * Use `create(GetTeamMemberBalanceResponseSchema)` to create a new message.
 */
export const GetTeamMemberBalanceResponseSchema: GenMessage<GetTeamMemberBalanceResponse, {jsonType: GetTeamMemberBalanceResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 33);

/**
 * @generated from message creativefabrica.coins.v2.ListCoinDealsRequest
 */
export type ListCoinDealsRequest = Message<"creativefabrica.coins.v2.ListCoinDealsRequest"> & {
  /**
   * If set, only deals in this campaign, for example "black_friday".
   * Otherwise every deal.
   *
   * @generated from field: optional string campaign = 1;
   */
  campaign?: string | undefined;
};

/**
 * @generated from message creativefabrica.coins.v2.ListCoinDealsRequest
 */
export type ListCoinDealsRequestJson = {
  /**
   * If set, only deals in this campaign, for example "black_friday".
   * Otherwise every deal.
   *
   * @generated from field: optional string campaign = 1;
   */
  campaign?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.ListCoinDealsRequest.
 * Use `create(ListCoinDealsRequestSchema)` to create a new message.
 */
export const ListCoinDealsRequestSchema: GenMessage<ListCoinDealsRequest, {jsonType: ListCoinDealsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 34);

/**
 * @generated from message creativefabrica.coins.v2.ListCoinDealsResponse
 */
export type ListCoinDealsResponse = Message<"creativefabrica.coins.v2.ListCoinDealsResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.coins.v2.CoinDeal deals = 1;
   */
  deals: CoinDeal[];
};

/**
 * @generated from message creativefabrica.coins.v2.ListCoinDealsResponse
 */
export type ListCoinDealsResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.coins.v2.CoinDeal deals = 1;
   */
  deals?: CoinDealJson[];
};

/**
 * Describes the message creativefabrica.coins.v2.ListCoinDealsResponse.
 * Use `create(ListCoinDealsResponseSchema)` to create a new message.
 */
export const ListCoinDealsResponseSchema: GenMessage<ListCoinDealsResponse, {jsonType: ListCoinDealsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 35);

/**
 * The authenticated user is inferred from the request context. The invoice
 * currency is the payments customer's saved currency.
 *
 * @generated from message creativefabrica.coins.v2.BuyCoinDealRequest
 */
export type BuyCoinDealRequest = Message<"creativefabrica.coins.v2.BuyCoinDealRequest"> & {
  /**
   * @generated from field: string deal_id = 1;
   */
  dealId: string;
};

/**
 * The authenticated user is inferred from the request context. The invoice
 * currency is the payments customer's saved currency.
 *
 * @generated from message creativefabrica.coins.v2.BuyCoinDealRequest
 */
export type BuyCoinDealRequestJson = {
  /**
   * @generated from field: string deal_id = 1;
   */
  dealId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.BuyCoinDealRequest.
 * Use `create(BuyCoinDealRequestSchema)` to create a new message.
 */
export const BuyCoinDealRequestSchema: GenMessage<BuyCoinDealRequest, {jsonType: BuyCoinDealRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 36);

/**
 * @generated from message creativefabrica.coins.v2.BuyCoinDealResponse
 */
export type BuyCoinDealResponse = Message<"creativefabrica.coins.v2.BuyCoinDealResponse"> & {
  /**
   * @generated from field: creativefabrica.coins.v2.CoinDealPaymentStatus payment_status = 1;
   */
  paymentStatus: CoinDealPaymentStatus;

  /**
   * Set when the payment needs another step, such as 3DS.
   *
   * @generated from field: string pay_invoice_url = 2;
   */
  payInvoiceUrl: string;
};

/**
 * @generated from message creativefabrica.coins.v2.BuyCoinDealResponse
 */
export type BuyCoinDealResponseJson = {
  /**
   * @generated from field: creativefabrica.coins.v2.CoinDealPaymentStatus payment_status = 1;
   */
  paymentStatus?: CoinDealPaymentStatusJson;

  /**
   * Set when the payment needs another step, such as 3DS.
   *
   * @generated from field: string pay_invoice_url = 2;
   */
  payInvoiceUrl?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.BuyCoinDealResponse.
 * Use `create(BuyCoinDealResponseSchema)` to create a new message.
 */
export const BuyCoinDealResponseSchema: GenMessage<BuyCoinDealResponse, {jsonType: BuyCoinDealResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 37);

/**
 * @generated from message creativefabrica.coins.v2.UpdateCoinDealQuantityRequest
 */
export type UpdateCoinDealQuantityRequest = Message<"creativefabrica.coins.v2.UpdateCoinDealQuantityRequest"> & {
  /**
   * @generated from field: string deal_id = 1;
   */
  dealId: string;

  /**
   * Display quantity. Zero is allowed. A negative quantity is rejected.
   *
   * @generated from field: int64 quantity = 2;
   */
  quantity: bigint;
};

/**
 * @generated from message creativefabrica.coins.v2.UpdateCoinDealQuantityRequest
 */
export type UpdateCoinDealQuantityRequestJson = {
  /**
   * @generated from field: string deal_id = 1;
   */
  dealId?: string;

  /**
   * Display quantity. Zero is allowed. A negative quantity is rejected.
   *
   * @generated from field: int64 quantity = 2;
   */
  quantity?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.UpdateCoinDealQuantityRequest.
 * Use `create(UpdateCoinDealQuantityRequestSchema)` to create a new message.
 */
export const UpdateCoinDealQuantityRequestSchema: GenMessage<UpdateCoinDealQuantityRequest, {jsonType: UpdateCoinDealQuantityRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 38);

/**
 * @generated from message creativefabrica.coins.v2.UpdateCoinDealQuantityResponse
 */
export type UpdateCoinDealQuantityResponse = Message<"creativefabrica.coins.v2.UpdateCoinDealQuantityResponse"> & {
  /**
   * @generated from field: creativefabrica.coins.v2.CoinDeal deal = 1;
   */
  deal?: CoinDeal | undefined;
};

/**
 * @generated from message creativefabrica.coins.v2.UpdateCoinDealQuantityResponse
 */
export type UpdateCoinDealQuantityResponseJson = {
  /**
   * @generated from field: creativefabrica.coins.v2.CoinDeal deal = 1;
   */
  deal?: CoinDealJson;
};

/**
 * Describes the message creativefabrica.coins.v2.UpdateCoinDealQuantityResponse.
 * Use `create(UpdateCoinDealQuantityResponseSchema)` to create a new message.
 */
export const UpdateCoinDealQuantityResponseSchema: GenMessage<UpdateCoinDealQuantityResponse, {jsonType: UpdateCoinDealQuantityResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 39);

/**
 * CoinsService is the v2 Connect-RPC surface for the coins product.
 *
 * v2 starts with static pricing, authenticated balance reads and auto top-up
 * settings. Transaction list, spend, tip, admin, subscription-gating and
 * event-shaped RPCs all stay on v1 until they're individually justified for
 * migration. Start small; add later.
 *
 * @generated from service creativefabrica.coins.v2.CoinsService
 */
export const CoinsService: GenService<{
  /**
   * GetPricing returns static coin pricing for a single action or every
   * known action. Replaces the GetConfig spend-action breakdown for v2
   * clients. Surface-specific variants (e.g. Lumo) are encoded as distinct
   * PricingAction enum values.
   *
   * @generated from rpc creativefabrica.coins.v2.CoinsService.GetPricing
   */
  getPricing: {
    methodKind: "unary";
    input: typeof GetPricingRequestSchema;
    output: typeof GetPricingResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.GetBalance
   */
  getBalance: {
    methodKind: "unary";
    input: typeof GetBalanceRequestSchema;
    output: typeof GetBalanceResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.GetAutoTopUpSettings
   */
  getAutoTopUpSettings: {
    methodKind: "unary";
    input: typeof GetAutoTopUpSettingsRequestSchema;
    output: typeof GetAutoTopUpSettingsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.UpdateAutoTopUpSettings
   */
  updateAutoTopUpSettings: {
    methodKind: "unary";
    input: typeof UpdateAutoTopUpSettingsRequestSchema;
    output: typeof UpdateAutoTopUpSettingsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.GetTeamSettings
   */
  getTeamSettings: {
    methodKind: "unary";
    input: typeof GetTeamSettingsRequestSchema;
    output: typeof GetTeamSettingsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.UpdateTeamSettings
   */
  updateTeamSettings: {
    methodKind: "unary";
    input: typeof UpdateTeamSettingsRequestSchema;
    output: typeof UpdateTeamSettingsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.ListTeamMembersStats
   */
  listTeamMembersStats: {
    methodKind: "unary";
    input: typeof ListTeamMembersStatsRequestSchema;
    output: typeof ListTeamMembersStatsResponseSchema;
  },
  /**
   * Lists coin usage for team API keys that spent in the period. Keys with
   * no spend are omitted. Spend is the apikey: tracking bucket overflow_used
   * and is already included in GetTeamStatistics team/total spent via pool used.
   *
   * @generated from rpc creativefabrica.coins.v2.CoinsService.ListTeamApiKeyStats
   */
  listTeamApiKeyStats: {
    methodKind: "unary";
    input: typeof ListTeamApiKeyStatsRequestSchema;
    output: typeof ListTeamApiKeyStatsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.ListUserTransactionStats
   */
  listUserTransactionStats: {
    methodKind: "unary";
    input: typeof ListUserTransactionStatsRequestSchema;
    output: typeof ListUserTransactionStatsResponseSchema;
  },
  /**
   * Lists one member's coin spend per calendar month, newest first, starting
   * at their first month with usage. Unlike the StatisticsPeriod endpoints
   * these are calendar months, not the team's billing cycles, so the numbers
   * differ for a team whose anchor day is not the 1st.
   *
   * @generated from rpc creativefabrica.coins.v2.CoinsService.ListTeamMemberMonthlyUsage
   */
  listTeamMemberMonthlyUsage: {
    methodKind: "unary";
    input: typeof ListTeamMemberMonthlyUsageRequestSchema;
    output: typeof ListTeamMemberMonthlyUsageResponseSchema;
  },
  /**
   * Lists one member's individual team-funded spends, newest first.
   *
   * @generated from rpc creativefabrica.coins.v2.CoinsService.ListTeamMemberActivity
   */
  listTeamMemberActivity: {
    methodKind: "unary";
    input: typeof ListTeamMemberActivityRequestSchema;
    output: typeof ListTeamMemberActivityResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.GetTeamStatistics
   */
  getTeamStatistics: {
    methodKind: "unary";
    input: typeof GetTeamStatisticsRequestSchema;
    output: typeof GetTeamStatisticsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.GetTeamBalance
   */
  getTeamBalance: {
    methodKind: "unary";
    input: typeof GetTeamBalanceRequestSchema;
    output: typeof GetTeamBalanceResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.GetTeamMemberBalance
   */
  getTeamMemberBalance: {
    methodKind: "unary";
    input: typeof GetTeamMemberBalanceRequestSchema;
    output: typeof GetTeamMemberBalanceResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.AdjustTeamBalance
   */
  adjustTeamBalance: {
    methodKind: "unary";
    input: typeof AdjustTeamBalanceRequestSchema;
    output: typeof AdjustTeamBalanceResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.AdjustTeamMemberBalance
   */
  adjustTeamMemberBalance: {
    methodKind: "unary";
    input: typeof AdjustTeamMemberBalanceRequestSchema;
    output: typeof AdjustTeamMemberBalanceResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.ListTeamTransactions
   */
  listTeamTransactions: {
    methodKind: "unary";
    input: typeof ListTeamTransactionsRequestSchema;
    output: typeof ListTeamTransactionsResponseSchema;
  },
  /**
   * Public. Lists the coin deals that are live now, with how many have been
   * sold. Deals that have not started or have ended are left out. Sold may
   * exceed quantity: deals are never blocked when they run out.
   *
   * @generated from rpc creativefabrica.coins.v2.CoinsService.ListCoinDeals
   */
  listCoinDeals: {
    methodKind: "unary";
    input: typeof ListCoinDealsRequestSchema;
    output: typeof ListCoinDealsResponseSchema;
  },
  /**
   * Charges the authenticated user for one coin deal. Fails with
   * InvalidArgument when the deal is unknown or not live now. It does not
   * check how many are left. Coins are credited, and the sale counted, once
   * the invoice is paid.
   *
   * @generated from rpc creativefabrica.coins.v2.CoinsService.BuyCoinDeal
   */
  buyCoinDeal: {
    methodKind: "unary";
    input: typeof BuyCoinDealRequestSchema;
    output: typeof BuyCoinDealResponseSchema;
  },
  /**
   * Sets the display quantity of one coin deal. The deal stays buyable when
   * sold passes this number. The caller must hold the manage promotions
   * admin capability.
   *
   * @generated from rpc creativefabrica.coins.v2.CoinsService.UpdateCoinDealQuantity
   */
  updateCoinDealQuantity: {
    methodKind: "unary";
    input: typeof UpdateCoinDealQuantityRequestSchema;
    output: typeof UpdateCoinDealQuantityResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_coins_v2_service, 0);

